import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { FormGroup } from '@angular/forms';
import { FormlyFormOptions } from '@ngx-formly/core';
import { LanguageService } from 'src/app/_services/language.service';

@Component({
  selector: 'app-progetto-edit',
  standalone: false,
  templateUrl: './progetto-edit.component.html',
  styleUrl: './progetto-edit.component.scss',
  providers: [MessageService],
})
export class ProgettoEditComponent implements OnInit {
  form = new FormGroup({});
  model: any = {
    status:'PROSPECT',
    project_type:'PROGETTO',
    billings:[],
    steps:[],
    year:new Date().getFullYear()
  };
  options: FormlyFormOptions = {};
  tabsFields:any[]=[];
  
  pageTitle:string="Nuovo progetto";
  backUrl:string='/projects';
  action:any='';
  loading:boolean = true;
  selectedItems:any[]=[];
  billingsListParams:any={};
  stepsListParams:any={};

  constructor(
    private apiService: ApiService,
    public globalService : GlobalService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    public lang:LanguageService,
    public router: Router,
  ) { }

  ngOnInit(): void {
    
    let modulefields=this.globalService.configModules.filter((m)=>m.name=='projects');
    this.tabsFields=modulefields[0].tabsFields;
    this.tabsFields.forEach((e:any)=>{
      if(e.fields){
        e.fields.forEach((f:any)=>{
          if(f.fieldGroup){
            f.fieldGroup.forEach((g:any)=>{
              if((g.props.options)&&(typeof g.props.options == 'string')) {
                g.props.options=this.apiService.postobs(g.props.options,{});   
                g.props['valueProp']='id';
                g.props['labelProp']='name';
              }
            });
          }
        });
      }
    });
   
    this.action=this.route.snapshot.paramMap.get('action');
    if(this.route.snapshot.paramMap.get('id')){
      this.billingsListParams={
        foreign_key:'project_id',
        foreign_key_value:this.route.snapshot.paramMap.get('id')
      }
      this.stepsListParams={
        foreign_key:'project_id',
        foreign_key_value:this.route.snapshot.paramMap.get('id')
      }
      
    
     
      this.pageTitle="Modifica progetto";
      this.apiService.post('app/projects_listall',{id:this.route.snapshot.paramMap.get('id')}).subscribe(data2 => {
        this.model = data2.Result[0];
        this.setDatePickers();
        if(!this.model.billings){
          this.model.billings=[];
        }
        if(!this.model.steps){
          this.model.steps=[];
        }
      });
    }
 
  }
  setDatePickers(){
    this.tabsFields.forEach((e:any)=>{
      if(e.fields){
        e.fields.forEach((f:any)=>{
          if(f.fieldGroup){
            f.fieldGroup.forEach((g:any)=>{
              if(g.type=='datepicker') {
                this.model[g.key]=new Date(this.model[g.key]);
              }
            });
          }
        });
      }
    });
  }
  valida(){
  return true;
  }
  dataListFromBillings(data:any){
    this.model.billings=data;
  }
  dataListFromSteps(data:any){
    this.model.steps=data;
  }
  save(){
    this.apiService.post('app/projects_update',this.model).subscribe(data => {
      this.addSingle('success', this.lang.el('Successo'), this.lang.el('Record aggiornato'));
      if(this.action!='update'){
        this.router.navigateByUrl('projects/projects-edit/update/'+data.Result.id);
      } else {
        this.router.navigateByUrl(this.backUrl);
      }
     
    });
  }
  
  delete(){

  }

  annulla(){
    this.router.navigateByUrl(this.backUrl);
  }

  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }
  
  onGlobalFilter(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }
  
}
